const InstructorDataHandler = {

    getInformation(key = null) {
        const information = {
            defaultPhoto: require('@/assets/images/instructor.jpg'),
            name: 'Victoria Ibarra',
            title: 'English and Spanish Teacher',
            about: `English & Spanish simplified for the real world.
                No-nonsense coaching to help you speak with confidence.
                Bridging cultures and languages through practical lessons.
                Ready to level up? Start your journey to fluency today.`,
            links: [
                { url: 'https://www.instagram.com/teachermaestravictoria/', icon: 'pi pi-instagram' },
                { url: 'https://www.instagram.com/teachermaestravictoria/', icon: 'pi pi-instagram' },
                { url: 'https://www.instagram.com/teachermaestravictoria/', icon: 'pi pi-instagram' },
                { url: 'https://www.instagram.com/teachermaestravictoria/', icon: 'pi pi-instagram' }
            ]
        }

        return key && information[key] != undefined ? information[key] : null;
    },

    /**
     * Gets path for instructor photo path
     * @returns {string}
     */
    getInstructorPhoto() {
        return this.getInformation('defaultPhoto');
    },

    /**
     * Gets all links
     * @returns {Array}
     */
    getLinks() {
        const links = this.getInformation('links');

        return Array.isArray(links) ? links : [];
    }
}

export default InstructorDataHandler;